import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { ProductsFilter } from "../../../components/dashboard/products/products-filter";
import DashboardHeader from "../../../components/dashboard/dashboardHeader";
import {
  ArrowPathRoundedSquareIcon,
  ArrowUpIcon,
  CheckBadgeIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";
import { pageOptions } from "../../../components/Utils";
import { ProductActionEditBar } from "../../../components/dashboard/products/product-action-edit-bar";
import { DrivingTripsTable } from "../../../components/dashboard/driving_record/trips/trips-table";
import { getDrivingTripsAsync } from "../../../slices/driving/trip";

export const HourList = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const tripsState = useSelector((store) => {
    return store.drivingTrips;
  });

  const { isLoading } = tripsState;
  const [selectedItems, setSelectedItems] = useState([]);
  const [controller, setController] = useState({
    filters: [],
    page: searchParams.get("page") ? searchParams.get("page") : 1,
    per_page: searchParams.get("per_page") ? searchParams.get("per_page") : 20,
    query: searchParams.get("query") ? searchParams.get("query") : "",
    sort: searchParams.get("sort") ? searchParams.get("sort") : "asc",
    sortBy: searchParams.get("sortBy")
      ? searchParams.get("sortBy")
      : "created_at",
    view: searchParams.get("view") ? searchParams.get("view") : "all",
  });

  const updateSearchParams = (controller) => {
    setSearchParams(controller);
  };

  useEffect(() => {
    updateSearchParams({
      page: controller.page,
      per_page: controller.per_page,
      query: controller.query,
      sort: controller.sort,
      sortBy: controller.sortBy,
      view: controller.view,
    });
  }, [controller]);

  const handleQueryChange = (newQuery) => {
    setController({
      ...controller,
      page: 1,
      query: newQuery,
    });
  };

  const handlePageChange = (newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handlePagePageChange = (option) => {
    setController({
      ...controller,
      per_page: option,
    });
  };

  useEffect(() => {
    const payload = {
      filters: controller.filters,
      page: controller.page,
      per_page: controller.per_page,
      query: controller.query,
      sort: controller.sort,
      sortBy: controller.sortBy,
      view: controller.view,
    };
    dispatch(getDrivingTripsAsync(payload));
  }, [dispatch, controller]);

  const [editModalOpen, setEditModalOpen] = useState(false);

  const headerActions = [];

  const headerMeta = [
    {
      label: tripsState.totalCount + " Trips",
      description: "wdw",
      path: null,
      action: null,
      icon: CheckBadgeIcon,
      textColor: "text-teal-700",
      hidden: false,
    },
    {
      label: tripsState.synchedWithApiCount + " Synched with Automile",
      description: "",
      path: null,
      action: null,
      icon: ArrowUpIcon,
      textColor: "text-teal-700",
      hidden: false,
    },
  ];

  const [multiEditDialogOpen, setMultiEditDialogOpen] = useState(false);
  const [priceChangeDialogOpen, setPriceChangeDialogOpen] = useState(false);

  const sortByOptions = [
    { name: "Seneste (Rapportnr.)", sort: "asc", sortBy: "report_number" },
    { name: "Eldste (Rapportnr.)", sort: "desc", sortBy: "report_number" },
  ];

  const initialFilters = [
    {
      id: "category",
      name: t("Category"),
      optionsUrl: "/products/categories/",
      optionsParams: {},
    },
    {
      id: "view",
      name: "view",
      // options: reportViewsOptions,
    },
    {
      id: "status",
      name: "status",
      // options: reportStatusesOptions,
    },
  ];

  return (
    <>
      <DashboardHeader
        subtitle=""
        actions={headerActions}
        title={"Trips"}
        meta={headerMeta}
        mainButton={{
          label: "New",
          action: () => setEditModalOpen(true),
          path: null,
          color: "",
          icon: PlusIcon,
        }}
      >
        <div className="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
          <div className="space-y-6 lg:col-span-3 lg:col-start-1 sm:col-span-3">
            <ProductsFilter
              className={"mt-10"}
              disabled={isLoading}
              onQueryChange={handleQueryChange}
              query={controller.query}
              selectedItems={selectedItems}
              sortByOptions={sortByOptions}
              perPageOptions={[10, 25, 50, 100, 250]}
              onPerPageChange={handlePagePageChange}
              pageOptions={pageOptions({
                perPage: controller?.per_page,
                totalCount: tripsState?.totalCount,
              })}
              onPageChange={handlePageChange}
              initialFilters={initialFilters}
              actionBar={
                <ProductActionEditBar
                  selectedItems={selectedItems}
                  setMultiEditDialogOpen={() => setMultiEditDialogOpen(true)}
                  setPriceChangeDialogOpen={() =>
                    setPriceChangeDialogOpen(true)
                  }
                />
              }
            />
            <DrivingTripsTable
              onItemsSelect={(items) => setSelectedItems(items)}
              itemState={tripsState}
              currentCount={tripsState.currentCount}
              page={controller.page}
              onPageChange={handlePageChange}
              perPage={controller.per_page}
            />
          </div>
        </div>
      </DashboardHeader>
    </>
  );
};
